import CustomModal from "@UI/CustomModal"
import PropTypes from "prop-types"
import './styles.css'
import { Button, Form } from "antd"
import { CustomSelect } from "@UI/CustomSelect"
import { CustomInput } from "@UI/CustomInput"
import { ReactComponent as InfoIcon } from '@pages/collectionAdministration/pages/NewEditTemplateCollection/components/NewEditTemplateCollectionBody/components/NewEditTemplateCollectionBodyOptions/assets/infoTooltipIcon.svg'
import CustomPopoverConfirm from "@UI/CustomPopoverConfirm"
import { useRecurrencyModal } from "./hooks/useRecurrencyModal"

const RecurrencyModal = ({
  isOpenModal,
  handleOpenCloseModal
}) => {
  const {
    form,
    isSingleCode,
    frecuencyRecurrencyOptions,
    buttonsOptions,
    handleSaveRecurrence,
    handleChangeRecurrenceMethod
  } = useRecurrencyModal({ handleOpenCloseModal, isOpenModal })

  return (
    <CustomModal
      destroyOnClose={true}
      className="custom-modal"
      isOpenModal={isOpenModal}
      onCancel={() => {
        handleOpenCloseModal({ isOpenModal: false })
        form.resetFields()
      }}
      width={450}
    >
      <div className="recurrency-modal-title">
        <span>Recurrencia</span>
        <CustomPopoverConfirm
          placement={'bottom'}
          overlayClassName={'info-tooltip-popover'}
          content={<div className="info-tooltip-popover-content">
            <p>Elige el tipo de cobro adecuado para tu necesidad</p>
            <p>Cobro único: Se genera una sola vez con una fecha de emisión y una fecha límite de pago.</p>
            <p>Cobro recurrente: Se repite automáticamente en un intervalo definido (semanal, mensual, etc.), con una fecha de emisión y un plazo específico para el pago."</p>
          </div>}
          maxWidth={325}
        >
          <Button icon={<InfoIcon />} className="btn-standard-transparent" shape="circle" style={{ marginLeft: '8px', width: '32px' }} />
        </CustomPopoverConfirm>
      </div>
      <div className="recurrency-modal-options">
        {
          buttonsOptions.map((item, index) => ({ ...item, key: index })).map((item) => (
            <Button
              key={item.key}
              className={item.code === isSingleCode ? 'btn-standard-green' : 'btn-standard-white'}
              shape="round" style={{ width: '150px' }}
              onClick={() => handleChangeRecurrenceMethod({ code: item.code, value: item.id })}>
              {item.name}
            </Button>
          ))
        }
      </div>
      <Form
        className="recurrency-modal-form"
        form={form}
        layout="vertical"
        onFinish={(values) => handleSaveRecurrence({ values })}
      >
        <Form.Item
          label="Frecuencia de cobro"
          name="charge_recurrence_frequency_id"
          rules={[{ required: true, message: 'El campo es necesario' }]}
          noStyle={isSingleCode === 'single'}
        >
          {isSingleCode !== 'single' &&
            <CustomSelect
              placeholder={'Diaria, Mensual, Semanal, etc.'}
              options={frecuencyRecurrencyOptions}
            />}
        </Form.Item>
        <Form.Item
          label="Día de emisión"
          name="issue_day"
          rules={[{ required: true, message: 'El campo es necesario' }]}
        >
          <CustomInput
            type="NUMBER"
            step={1}
            min={1}
            max={30}
            placeholder={'Día en que generará cada cobro'}
            nullInputNumberText={null}
          />
        </Form.Item>
        <Form.Item
          label="Días para pagar despues de la emisión"
          name="due_day"
          rules={[{ required: true, message: 'El campo es necesario' }]}
        >
          <CustomInput
            type="NUMBER"
            step={1}
            min={1}
            max={30}
            placeholder={'Días para pagar despues de la emisión'}
            nullInputNumberText={null}
          />
        </Form.Item>
        <div className="recurrency-modal-form-footer">
          <Button htmlType="submit" className="btn-standard-green" shape="round" style={{ width: '133px' }}>
            GUARDAR
          </Button>
        </div>
      </Form>
    </CustomModal>
  )
}

RecurrencyModal.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  handleOpenCloseModal: PropTypes.func.isRequired
}

export default RecurrencyModal
